/**
 * Created by mac on 10/12/22
 */

const CloseButton = cleverapps.UI.Button.extend({
    avoidNode: "CloseButton",

    ctor: function (options) {
        this.options = options;

        this._super({
            type: {
                button_png: bundles.buttons_main.frames.window_close_png,
                button_on_png: bundles.buttons_main.frames.window_close_on_png
            },
            onClicked: options.onClicked,
            click_effect: undefined
        });

        this.setLocalZOrder(3);
        this.onResize();
    },

    // styles: false means the node declares ScaleComponent / AlignmentComponent itself - the prefab
    // path always does, so the button must not fight them (ScaleComponent keeps baseScale up to date)
    onResize: function () {
        if (this.options.styles === false) {
            return;
        }

        const styles = this.options.scale || cleverapps.styles.CloseButton.scale;
        this.baseScale = styles[cleverapps.resolution.mode];
        this.setScale(this.baseScale);

        this.setAlignment(this.options.styles || cleverapps.styles.CloseButton.position);
    },

    hide: function () {
        this.setVisible(false);
    },

    show: function () {
        this.runAction(
            new cc.Sequence(
                new cc.ScaleTo(0, 0.3 * this.baseScale),
                new cc.Show(),
                new cc.ScaleTo(0.4, this.baseScale).easing(cc.easeBackOut())
            )
        );
    }
});

cleverapps.styles.CloseButton = {
    scale: [0.7, 1, 1],

    position: {
        x: { align: "right", dx: 20 },
        y: { align: "top", dy: 20 }
    }
};